import logger from '../../../util/logger';
import { convertYYYYMMDD } from '../../../util/date-time';
export function marketsOptionGreeksTransform(data, params) {
    /**
     * data format
    {
        rootInstrument: '126.1.IBM',
        greeks: [{
            instrument: '126.2.IBM7UFC075000',
            delta: '-0.0027',
            date: '20170915',
            gamma: '0.0002',
            iVol: '2.3118',
            rho: '0',
            theta: '-0.0358',
            vega: '0.0012'
        }, {
            instrument: "126.2.IBM7UFC075000",
            delta: "-0.0027",
            date: "20170915",
            gamma: "0.0002",
            iVol: "2.3118",
            rho: "0",
            theta: "-0.0358",
            vega: "0.0012"
        }, ...]
    }
    */
    const root = params.root;
    const ret = {
        rootInstrument: root
    };
    if (!data || data.Status.ErrorMsg !== 'Succeeded') {
        logger.warn(
            'morningstar.marketdata.optionGreeks',
            'has not data return',
            {}
        );
        return ret;
    }

    if (data.Data && data.Data[root]) {
        ret.greeks = [];
        const items = data.Data[root]['Greeks'] || [];
        items.forEach(item => {
            const obj = {};
            obj['delta'] = item['Delta'] || '';
            obj['gamma'] = item['Gamma'] || '';
            obj['rho'] = item['Rho'] || '';
            obj['theta'] = item['Theta'] || '';
            obj['vega'] = item['Vega'] || '';
            obj['iVol'] = String(item['ImpliedVolatility'] * 100);
            obj['date'] = convertYYYYMMDD(item['ExpireDate']) || '';
            obj['instrument'] = item['Ticker'] || '';

            ret.greeks.push(obj);
        });
    }
    return ret;
}
